/**
 * @prettier
 * @flow
 */
import InputAdornment from '@material-ui/core/InputAdornment';
import TextField from '@material-ui/core/TextField';
import * as React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import NumberFormat from 'react-number-format';
import { translate } from 'src/utils/translate/translate';

export function FormCurrencyAmountField({ name, label, placeholder, helperText, value, onChange, variant = 'outlined', required, disabled, InputProps, rules, defaultValue = '' }: Props) {
    const {
        errors,
        control,
        formState: { isSubmitting },
    } = useFormContext();
    // const { errors, control, formState: { isSubmitting }, watch } = useFormContext();

    // const v = watch(name);

    return (
        <Controller
            as={TextField}
            name={name}
            label={label}
            placeholder={placeholder}
            helperText={errors[name]?.message ?? helperText}
            rules={{
                required: rules?.required && {
                    value: rules?.required ?? (rules?.required: any)?.value,
                    message: (rules?.required: any)?.message ?? translate('This field is required'),
                },
                pattern: rules?.email && {
                    value: /.*@.*\..*/,
                    message: (rules?.email: any)?.message ?? translate('Must be an email'),
                },
                min: rules?.min && {
                    value: rules?.min ?? (rules?.min: any)?.value,
                    message: (rules?.min: any)?.message ?? translate('Must be number less than @number', { number: (rules?.min: any) }),
                },
                max: rules?.max && {
                    value: rules?.max ?? (rules?.max: any)?.value,
                    message: (rules?.max: any)?.message ?? translate('Must be number larger than @number', { number: (rules?.max: any) }),
                },
                minLength: rules?.minLength && {
                    value: rules?.minLength ?? (rules?.minLength: any)?.value,
                    message: (rules?.minLength: any)?.message ?? translate('Must be at least @number characters', { number: (rules?.minLength: any) }),
                },
                maxLength: rules?.maxLength && {
                    value: rules?.maxLength ?? (rules?.maxLength: any)?.value,
                    message: (rules?.maxLength: any)?.message ?? translate('Must be at most @number characters', { number: (rules?.maxLength: any) }),
                },
            }}
            error={errors[name]}
            value={value}
            onChange={onChange}
            InputProps={{
                inputComponent: NumberFormatCustom,
                endAdornment: <InputAdornment position='end'>$</InputAdornment>,
                // startAdornment: !!v ? <InputAdornment position="start">$</InputAdornment> : undefined,
                // endAdornment: !v ? <InputAdornment position="end">$</InputAdornment> : undefined,
                ...InputProps,
            }}
            InputLabelProps={{ shrink: placeholder ? true : undefined }}
            variant={variant}
            required={required}
            disabled={isSubmitting || disabled}
            fullWidth
            control={control}
            defaultValue={defaultValue}
        />
    );
}

export function NumberFormatCustom(props: { inputRef: any, name: string, onChange: Function }) {
    const { inputRef, onChange, ...other } = props;

    return (
        <NumberFormat
            {...other}
            getInputRef={inputRef}
            onValueChange={values => onChange(values.value)}
            thousandSeparator
            isNumericString
            decimalScale={2}
            // prefix="$"
        />
    );
}

type Props = {|
    name: string,
    label?: string,
    placeholder?: string,
    helperText?: string,
    value?: string,
    onChange?: string,
    variant?: 'filled' | 'outlined' | 'standard',
    required?: boolean,
    disabled?: boolean,
    rules?: {|
        required?: boolean,
        email?: boolean,
        min?: number | { message: string, value: number },
        max?: number | { message: string, value: number },
        minLength?: number | { message: string, value: number },
        maxLength?: number | { message: string, value: number },
    |},
    InputProps?: any,
    defaultValue?: string,
|};
